import { render, staticRenderFns } from "./TopTenDistributors.vue?vue&type=template&id=2d1f106c&"
import script from "./TopTenDistributors.vue?vue&type=script&lang=js&"
export * from "./TopTenDistributors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports